import { PureComponent } from 'react';
import { getParticipantDisplayName, isLocalParticipantModerator } from '../../base/participants/functions';
import { getDisplayName } from '../../visitors/functions';
import { setLobbyChatActiveState, setPrivateMessageRecipient } from '../actions.any';
import { isVisitorChatParticipant } from '../functions';
/**
 * Abstract class for the {@code MessageRecipient} component.
 */
export default class AbstractMessageRecipient extends PureComponent {
}
/**
 * Maps part of the props of this component to Redux actions.
 *
 * @param {Function} dispatch - The Redux dispatch function.
 * @returns {IProps}
 */
export function _mapDispatchToProps(dispatch) {
    return {
        _onRemovePrivateMessageRecipient: () => {
            dispatch(setPrivateMessageRecipient());
        },
        _onHideLobbyChatRecipient: () => {
            dispatch(setLobbyChatActiveState(false));
        }
    };
}
/**
 * Maps part of the Redux store to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @param {any} _ownProps - Components' own props.
 * @returns {IProps}
 */
export function _mapStateToProps(state, _ownProps) {
    const { privateMessageRecipient, lobbyMessageRecipient, isLobbyChatActive } = state['features/chat'];
    let _privateMessageRecipient;
    const _isVisitor = isVisitorChatParticipant(privateMessageRecipient);
    if (privateMessageRecipient) {
        _privateMessageRecipient = _isVisitor
            ? getDisplayName(state, privateMessageRecipient.name)
            : getParticipantDisplayName(state, privateMessageRecipient.id);
    }
    return {
        _privateMessageRecipient,
        _isVisitor,
        _isLobbyChatActive: isLobbyChatActive,
        _lobbyMessageRecipient: isLobbyChatActive && lobbyMessageRecipient ? lobbyMessageRecipient.name : undefined,
        _visible: isLobbyChatActive ? isLocalParticipantModerator(state) : true
    };
}
